/*
 * @Author: Gaho
 * @Date: 2024-03-27 15:10:57
 * @LastEditors: Gaho
 * @LastEditTime: 2024-03-27 17:47:57
 * @Description: 
 */
import { defineStore } from "pinia";
const initData = {
    bets: [0],
}
export const useLiveChatStore = defineStore('liveChat', {
    state: () => initData
})